<div [ngClass]="style" *ngIf="booking" class="pointer">
  <div [ngClass]="booking.status" class="d-flex carrousel text_3">
    <div (click)="openProperty(booking)"
      [ngStyle]="{ 'background-image': 'url(' + booking.property['cover_photo'] + ')' }" class="picture">
    </div>
    <div (click)="navigate(booking)" class="description d-flex flex-column justify-content-center">
      <h6 class="text_4 mb-0">
        {{ "PROFILE.PURCHASED.LF_FEES" | translate }} :
        {{booking && booking['reservation_fees'] ? booking['reservation_fees'] : (booking && booking.property ? booking.property['reservation_fees'] : 0)}}
        €
      </h6>
      <p class="text_3">{{booking && booking.property ? booking.property.name : 'N/A'}}</p>
      <p class="mb-2 text_3">{{ booking['start_date'] | date:'dd/MM/yyyy' }}
        - {{ booking['end_date'] | date:'dd/MM/yyyy' }}</p>

      <p class="subtitle_2">
        {{ 'COMMON.STATUS' | translate  }}:
        <span *ngIf="['Pending', 'Accepted', 'Declined', 'Cancelled'].includes(booking.status)" [ngClass]="'span'+booking.status">
          {{ ('COMMON.USER.' + booking.status.toUpperCase()) | translate }}
        </span>
        <span *ngIf="booking.status === 'Expired'" class="text-primary">
          {{ 'COMMON.USER.ENDED' | translate }}
        </span>
      </p>

      <button role="button" type="button" *ngIf="booking.status === 'Declined'" class="btn btn-lf-secondary mt-3">
        {{'COMMON.USER.VIEW_REASON' | translate }}
      </button>

      <button *ngIf="booking.status === 'Accepted'" role="button" type="button"
        class="btn btn-gradient-blue mt-3 justify-content-between align-items-center align-items-md-baseline"
        ngClass="fw-bold">
        {{'COMMON.USER.FINALISE_RESERVATION' | translate }}
        <lf-icon name="rightChevron" height="16px" width="16px"></lf-icon>
      </button>
      <a *ngIf="booking.status === 'Pending'" (click)="cancel(booking)"
        class="mt-3 mediumGray">{{'COMMON.USER.CANCEL' | translate }}</a>
    </div>
  </div>

  <h6 *ngIf="booking && booking.status == 'Accepted'" class="text_3 mt-3 ms-1 mb-4 mb-sm-5">
    {{'COMMON.USER.RESERVATION_ACCEPTED' | translate }}
  </h6>

</div>
